import Cookies from 'js-cookie';

const TOKEN_COOKIE_KEY = 'token';
const TOKEN_STORAGE_KEY = 'auth.token';
const ROLES_STORAGE_KEY = 'auth.roles';

const hasSessionStorage = () => {
  try {
    return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
  } catch (error) {
    return false;
  }
};

const readSessionValue = (key) => {
  if (!hasSessionStorage()) return '';
  try {
    return window.sessionStorage.getItem(key) || '';
  } catch (error) {
    return '';
  }
};

const writeSessionValue = (key, value) => {
  if (!hasSessionStorage()) return;
  try {
    if (value) {
      window.sessionStorage.setItem(key, value);
    } else {
      window.sessionStorage.removeItem(key);
    }
  } catch (error) {
    // Ignorado: el flujo sigue con cookies si storage no esta disponible.
  }
};

export const persistAuthToken = (token) => {
  const normalizedToken = typeof token === 'string' ? token.trim() : '';
  if (!normalizedToken) {
    Cookies.remove(TOKEN_COOKIE_KEY);
    writeSessionValue(TOKEN_STORAGE_KEY, '');
    return '';
  }

  writeSessionValue(TOKEN_STORAGE_KEY, normalizedToken);
  Cookies.remove(TOKEN_COOKIE_KEY);
  Cookies.set(TOKEN_COOKIE_KEY, normalizedToken);

  return getAuthToken();
};

export const getAuthToken = () => {
  const sessionToken = readSessionValue(TOKEN_STORAGE_KEY);
  if (sessionToken && sessionToken !== 'undefined') {
    return sessionToken;
  }

  const cookieToken = Cookies.get(TOKEN_COOKIE_KEY);
  if (cookieToken && cookieToken !== 'undefined') {
    return cookieToken;
  }
  
  return '';
};

export const persistStoredRoles = (roles) => {
  const serializedRoles = Array.isArray(roles) && roles.length ? JSON.stringify(roles) : '';
  Cookies.remove('roles');
  writeSessionValue(ROLES_STORAGE_KEY, serializedRoles);
  return serializedRoles;
};

export const getStoredRoles = () => {
  const storedRoles = readSessionValue(ROLES_STORAGE_KEY);
  if (storedRoles) return storedRoles;

  const legacyCookieRoles = Cookies.get('roles');
  return legacyCookieRoles || '';
};

export const clearAuthSession = () => {
  Cookies.remove(TOKEN_COOKIE_KEY);
  Cookies.remove('roles');
  Cookies.remove('refreshToken');
  Cookies.remove('role');
  Cookies.remove('expiresAt');
  Cookies.remove('user');
  Cookies.remove('username');
  Cookies.remove('uuid');
  Cookies.remove('deposit');
  writeSessionValue(TOKEN_STORAGE_KEY, '');
  writeSessionValue(ROLES_STORAGE_KEY, '');
};
